/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import 'moment/locale/fr';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { loadRuntimeConfig } from '@environments/runtime-config';
import { reportStartupFailure } from '@environments/startup-failure';
import { appConfig } from './app/app.config';
import { demoTourId, tabStorage } from './app/features/tours/demo/demo-mode';
import { App } from './app/app';

registerLocaleData(localeFr, 'fr-FR');

// `/config.json` est lu AVANT de construire les providers : c'est lui qui désigne l'API et
// l'annuaire, et Keycloak s'initialise dès le démarrage de l'application. Une même image sert
// ainsi le dev, la production et toutes les previews qui la déclarent.
// Un onglet ouvert sur `/decouverte/…` démarre en démonstration, pour toute sa vie : ses appels
// à l'API ne quittent pas le navigateur. Son code se charge à part, et seulement là.
loadRuntimeConfig()
  .then(async (runtimeConfig) => {
    const tourId = demoTourId(window.location.pathname, tabStorage());
    const demo = tourId
      ? (await import('./app/features/tours/demo/demo.providers')).demoProviders(
          tourId,
          runtimeConfig.apiUrl,
        )
      : [];
    return bootstrapApplication(App, appConfig(runtimeConfig, demo));
  })
  .catch((failure) => reportStartupFailure(failure));
